// DS: MO3.4.1
import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import DeviationShopCard from '../DeviationShopCard';
const PCPShopCard = ({ width, deviation, withAuthorDetails, withIndicators })=>{
    const pcp_download_count = useFlag('pcp_download_count');
    return /*#__PURE__*/ React.createElement(DeviationShopCard, {
        width: width,
        deviation: deviation,
        withStats: true,
        withPremiumDownloadCount: pcp_download_count,
        withDescriptionBlock: false,
        withAuthorDetails: withAuthorDetails,
        withIndicators: withIndicators
    });
};
PCPShopCard.displayName = 'PCPShopCard';
export default PCPShopCard;
